import { render, staticRenderFns } from "./RecruitmentMedia.vue?vue&type=template&id=36b3549e"
import script from "./RecruitmentMedia.vue?vue&type=script&lang=js"
export * from "./RecruitmentMedia.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentMedia.vue?vue&type=style&index=0&id=36b3549e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports